<ng-container *ngTemplateOutlet="isDesktop ? desktop : mobile"></ng-container>

<ng-template #desktop>
    <compliance-take-photo-desktop
        [userCanTakePhoto]="userCanTakePhoto"
        [canUseCurrentImage]="canUseCurrentImage"
        [requestData]="requestData"
        [uploadConfig]="uploadConfig"
        [cameraConfig]="cameraConfig"
        [userPhotoUrl]="userPhotoUrl"
        [photoData]="photoData"
        [newFileName]="newFileName"
        [isVisitorRequest]="isVisitorRequest"
        (onUseCurrentPhoto)="useCurrentPhoto()"
        (onDelete)="deletePhoto()"
        (onUpload)="onPhotoUploaded($event)"
        (onTakePhoto)="onPhotoTaken($event)"
    >
    </compliance-take-photo-desktop>
</ng-template>

<ng-template #mobile>
    <employee-take-photo-mobile
        [canUseCurrentImage]="canUseCurrentImage"
        [requestData]="requestData"
        [newFileName]="newFileName"
        [uploadConfig]="uploadConfig"
        [cameraConfig]="cameraConfig"
        [userPhotoUrl]="userPhotoUrl"
        [photoData]="photoData"
        [isVisitorRequest]="isVisitorRequest"
        (onUseCurrentPhoto)="useCurrentPhoto()"
        (onDelete)="deletePhoto()"
        (onUpload)="onPhotoUploaded($event)"
        (onTakePhoto)="onPhotoTaken($event)"
    >
    </employee-take-photo-mobile>
</ng-template>
